import React, {useState, useEffect} from 'react';
import Card from './Card';
import Data from '../data/home';
import Reviews from '../components/carousel';


function Home() {
    const [homeData, setHomeData] = useState(Data);
    const [cardData, setCardData] = useState([]);
        return ( 
            <>
                {homeData && ( // Check if homeData is defined
                    <div className="container" style={{ marginTop: '30px' }}>
                        <div className="row">
                            <div className="col-lg-12 mb-4 mt-2 text-center">
                                <h2 style={{ fontWeight: '700'}}>{ homeData?.marketing?.[0]?.title }</h2>
                            </div>
                        </div>
                    </div>
                )}
                {homeData?.marketing && ( // Check if homeData and homeData.marketing are defined
                    <div className="container ">
                        <div className="row">
                            { 
                                homeData.marketing.map( (marketing, index) => {
                                    if (index > 0 && index < 7 && marketing) { // Check if marketing is defined
                                        return (
                                            <Card 
                                                title={ marketing.title } 
                                                image={ marketing.image } 
                                                body={ marketing.body } 
                                                url={ marketing.url } 
                                                key={ 'infotile_' + marketing.id }
                                            ></Card>
                                        )
                                    }
                                })
                            }
                        </div>
                    </div>
                )}
                <div className="container ">
                    <div className="row">
                        <div className="col-sm-12 mt-4 mb-2 text-center">
                            <h2>{ homeData?.reviews?.title }</h2>
                        </div>
                    </div>
                    <Reviews></Reviews>
                </div>
            </>
        );
    }
export default Home;